var map = {
	"./accordion-close.svg": [
		1307,
		338
	],
	"./accordion-open.svg": [
		1308,
		337
	],
	"./activity-books.svg": [
		1309,
		336
	],
	"./activity-idea.svg": [
		1310,
		335
	],
	"./activity.svg": [
		1311,
		334
	],
	"./align-justify-solid.svg": [
		1312,
		333
	],
	"./all-books.svg": [
		1313,
		332
	],
	"./animal-stories.svg": [
		1314,
		331
	],
	"./arrow-down.svg": [
		1315,
		330
	],
	"./arrow-up.svg": [
		1316,
		329
	],
	"./attribution.svg": [
		1317,
		328
	],
	"./audio-mute.svg": [
		1318,
		327
	],
	"./audio.svg": [
		1319,
		326
	],
	"./avatar-clip.svg": [
		1320,
		325
	],
	"./back-to-top.svg": [
		1321,
		324
	],
	"./back.svg": [
		1322,
		323
	],
	"./badge.svg": [
		1323,
		322
	],
	"./baseline.svg": [
		1324,
		321
	],
	"./bell.svg": [
		1325,
		320
	],
	"./bin-new.svg": [
		1326,
		319
	],
	"./bin.svg": [
		1327,
		318
	],
	"./block-suggestions-for-story.svg": [
		1328,
		317
	],
	"./block-user.svg": [
		1329,
		316
	],
	"./blocked-suggestions-for-story.svg": [
		1330,
		315
	],
	"./blocked-user.svg": [
		1331,
		314
	],
	"./book-alt.svg": [
		1332,
		313
	],
	"./book-pencil.svg": [
		1333,
		312
	],
	"./book.svg": [
		1334,
		311
	],
	"./bookmark.svg": [
		1335,
		310
	],
	"./bookmarked.svg": [
		1336,
		309
	],
	"./cc.svg": [
		1337,
		308
	],
	"./certified.svg": [
		1338,
		307
	],
	"./check-mark.svg": [
		1339,
		306
	],
	"./check.svg": [
		1340,
		305
	],
	"./checkbox-active.svg": [
		1341,
		304
	],
	"./checkbox-inactive.svg": [
		1342,
		303
	],
	"./checkbox-off.svg": [
		1343,
		302
	],
	"./checkbox-on.svg": [
		1344,
		301
	],
	"./chevron-down.svg": [
		1345,
		300
	],
	"./chevron-left.svg": [
		1346,
		299
	],
	"./chevron-next.svg": [
		1347,
		298
	],
	"./chevron-prev.svg": [
		1348,
		297
	],
	"./chevron-right.svg": [
		1349,
		296
	],
	"./chevron-svg-next.svg": [
		1350,
		295
	],
	"./chevron-up.svg": [
		1351,
		294
	],
	"./circle.svg": [
		1352,
		293
	],
	"./class-profile.svg": [
		1353,
		292
	],
	"./close-circle.svg": [
		1354,
		291
	],
	"./close.svg": [
		1355,
		290
	],
	"./code.svg": [
		1356,
		289
	],
	"./complete-icon.svg": [
		1357,
		288
	],
	"./concept-books.svg": [
		1358,
		287
	],
	"./danger.svg": [
		1359,
		286
	],
	"./donate.svg": [
		1360,
		285
	],
	"./dots.svg": [
		1361,
		284
	],
	"./down-arrow.svg": [
		1362,
		283
	],
	"./download.svg": [
		1363,
		282
	],
	"./edit-student.svg": [
		1364,
		281
	],
	"./email.svg": [
		1365,
		280
	],
	"./endline.svg": [
		1366,
		279
	],
	"./enrolled.svg": [
		1367,
		278
	],
	"./environment.svg": [
		1368,
		277
	],
	"./eye.svg": [
		1369,
		276
	],
	"./facebook.svg": [
		1370,
		275
	],
	"./family-friends.svg": [
		1371,
		274
	],
	"./file_edit.svg": [
		1372,
		273
	],
	"./filter.svg": [
		1373,
		272
	],
	"./flag-filled.svg": [
		1374,
		271
	],
	"./flag.svg": [
		1375,
		270
	],
	"./flashcards.svg": [
		1376,
		269
	],
	"./folktales-myths.svg": [
		1377,
		268
	],
	"./foundational-literacy-in-classroom-hindi.svg": [
		1378,
		267
	],
	"./foundational-literacy-read-home-hindi.svg": [
		1379,
		266
	],
	"./fullscreen-exit.svg": [
		1380,
		265
	],
	"./fullscreen.svg": [
		1381,
		264
	],
	"./funny.svg": [
		1382,
		263
	],
	"./gcr-blue-check.svg": [
		1383,
		262
	],
	"./gcr-check.svg": [
		1384,
		261
	],
	"./gif.svg": [
		1385,
		260
	],
	"./gift.svg": [
		1386,
		259
	],
	"./globe.svg": [
		1387,
		258
	],
	"./gmail.svg": [
		1388,
		257
	],
	"./google-plus.svg": [
		1389,
		256
	],
	"./google.svg": [
		1390,
		255
	],
	"./grey-star.svg": [
		1391,
		254
	],
	"./header-branding-bounds.svg": [
		1392,
		253
	],
	"./heart-outline.svg": [
		1393,
		252
	],
	"./heart.svg": [
		1394,
		251
	],
	"./hide-password.svg": [
		1395,
		250
	],
	"./home.svg": [
		1396,
		249
	],
	"./house-chimney-solid.svg": [
		1397,
		248
	],
	"./house.svg": [
		1398,
		247
	],
	"./icon-plus.svg": [
		1399,
		246
	],
	"./icon-translate.svg": [
		1400,
		245
	],
	"./idea.svg": [
		1401,
		244
	],
	"./incomplete-icon.svg": [
		1402,
		243
	],
	"./independent-reading.svg": [
		1403,
		242
	],
	"./info-blue.svg": [
		1404,
		241
	],
	"./info-offline.svg": [
		1405,
		240
	],
	"./info.svg": [
		1406,
		239
	],
	"./information.svg": [
		1407,
		238
	],
	"./inprogess-icon.svg": [
		1408,
		237
	],
	"./instagram.svg": [
		1409,
		236
	],
	"./inverted-comma.svg": [
		1410,
		235
	],
	"./keyboard-voice.svg": [
		1411,
		234
	],
	"./lesson-plan.svg": [
		1412,
		233
	],
	"./library.svg": [
		1413,
		232
	],
	"./lifeskills.svg": [
		1414,
		231
	],
	"./link.svg": [
		1415,
		230
	],
	"./linkedIn.svg": [
		1416,
		229
	],
	"./list-inactive.svg": [
		1417,
		228
	],
	"./list-plus.svg": [
		1418,
		227
	],
	"./lists.svg": [
		1419,
		226
	],
	"./livestream.svg": [
		1420,
		225
	],
	"./loader.svg": [
		1421,
		224
	],
	"./lock.svg": [
		1422,
		223
	],
	"./locked.svg": [
		1423,
		222
	],
	"./mail.svg": [
		1424,
		221
	],
	"./math.svg": [
		1425,
		220
	],
	"./menu.svg": [
		1426,
		219
	],
	"./more-info.svg": [
		1427,
		218
	],
	"./mt-left-icon.svg": [
		1428,
		217
	],
	"./mt-right-icon.svg": [
		1429,
		216
	],
	"./navigate-back.svg": [
		1430,
		215
	],
	"./next-grade.svg": [
		1431,
		214
	],
	"./offline-icon.svg": [
		1432,
		213
	],
	"./offline.svg": [
		1433,
		212
	],
	"./party.svg": [
		1434,
		211
	],
	"./pause.svg": [
		1435,
		210
	],
	"./pen.svg": [
		1436,
		209
	],
	"./phone.svg": [
		1437,
		208
	],
	"./picture-books.svg": [
		1438,
		207
	],
	"./play-btn.svg": [
		1439,
		206
	],
	"./play.svg": [
		1440,
		205
	],
	"./plus-circle.svg": [
		1441,
		204
	],
	"./portrait.svg": [
		1442,
		203
	],
	"./profile-completion-check.svg": [
		1443,
		202
	],
	"./profile-completion-uncheck.svg": [
		1444,
		201
	],
	"./profile-edit.svg": [
		1445,
		200
	],
	"./progress-0.svg": [
		1446,
		199
	],
	"./progress-1.svg": [
		1447,
		198
	],
	"./progress-2.svg": [
		1448,
		197
	],
	"./progress-3.svg": [
		1449,
		196
	],
	"./progress-4.svg": [
		1450,
		195
	],
	"./progress-5.svg": [
		1451,
		194
	],
	"./progress-6.svg": [
		1452,
		193
	],
	"./progress-finish-0.svg": [
		1453,
		192
	],
	"./progress-finish-1.svg": [
		1454,
		191
	],
	"./progress-finish-2.svg": [
		1455,
		190
	],
	"./progress-finish-3.svg": [
		1456,
		189
	],
	"./progress-finish-4.svg": [
		1457,
		188
	],
	"./progress-finish-5.svg": [
		1458,
		187
	],
	"./progress-finish-6.svg": [
		1459,
		186
	],
	"./progress-flag.svg": [
		1460,
		185
	],
	"./quick-view.svg": [
		1461,
		184
	],
	"./quill.svg": [
		1462,
		183
	],
	"./radio-off.svg": [
		1463,
		182
	],
	"./radio-on.svg": [
		1464,
		181
	],
	"./read-along-old.svg": [
		1465,
		180
	],
	"./read-aloud-stories.svg": [
		1466,
		179
	],
	"./read-aloud.svg": [
		1467,
		178
	],
	"./read-bottom.svg": [
		1468,
		177
	],
	"./read-tab.svg": [
		1469,
		176
	],
	"./read.svg": [
		1470,
		175
	],
	"./readalong.svg": [
		1471,
		174
	],
	"./reading-left.svg": [
		1472,
		173
	],
	"./reading-program.svg": [
		1473,
		172
	],
	"./reading-right.svg": [
		1474,
		171
	],
	"./reads.svg": [
		1475,
		170
	],
	"./recommended.svg": [
		1476,
		169
	],
	"./red-right-arrow.svg": [
		1477,
		168
	],
	"./refresh.svg": [
		1478,
		167
	],
	"./resolve.svg": [
		1479,
		166
	],
	"./resource-check.svg": [
		1480,
		165
	],
	"./resource-video.svg": [
		1481,
		164
	],
	"./resource.svg": [
		1482,
		163
	],
	"./resources.svg": [
		1483,
		162
	],
	"./right-arrow.svg": [
		1484,
		161
	],
	"./right-click.svg": [
		1485,
		160
	],
	"./rp-arrow-left.svg": [
		1486,
		159
	],
	"./rp_odia_download.svg": [
		1487,
		158
	],
	"./rp_odia_download_disabled.svg": [
		1488,
		157
	],
	"./rss.svg": [
		1489,
		156
	],
	"./save-for-offline-translate.svg": [
		1490,
		155
	],
	"./say-thanks.svg": [
		1491,
		154
	],
	"./school-stories.svg": [
		1492,
		153
	],
	"./science-nature.svg": [
		1493,
		152
	],
	"./search.svg": [
		1494,
		151
	],
	"./sg-user.svg": [
		1495,
		150
	],
	"./share.svg": [
		1496,
		149
	],
	"./shared-reading.svg": [
		1497,
		148
	],
	"./show-password.svg": [
		1498,
		147
	],
	"./star.svg": [
		1499,
		146
	],
	"./stem-menu.svg": [
		1500,
		145
	],
	"./stemEnrol.svg": [
		1501,
		144
	],
	"./story_offline.svg": [
		1502,
		143
	],
	"./success.svg": [
		1503,
		142
	],
	"./suggest-edit.svg": [
		1504,
		141
	],
	"./suggestions-for-story.svg": [
		1505,
		140
	],
	"./sustainable-development-goals.svg": [
		1506,
		139
	],
	"./sw-logo.svg": [
		1507,
		138
	],
	"./telegramReal.svg": [
		1508,
		137
	],
	"./theme-arrow-down.svg": [
		1509,
		136
	],
	"./theme-arrow-up.svg": [
		1510,
		135
	],
	"./thumbs-up.svg": [
		1511,
		134
	],
	"./tick-circle-solid.svg": [
		1512,
		133
	],
	"./training-resource.svg": [
		1513,
		132
	],
	"./translate.svg": [
		1514,
		131
	],
	"./trending.svg": [
		1515,
		130
	],
	"./twitter-real.svg": [
		1516,
		129
	],
	"./twitter.svg": [
		1517,
		128
	],
	"./unlock.svg": [
		1518,
		127
	],
	"./up-arrow.svg": [
		1519,
		126
	],
	"./up-down.svg": [
		1520,
		125
	],
	"./upload-solid.svg": [
		1521,
		124
	],
	"./upload.svg": [
		1522,
		123
	],
	"./user.svg": [
		1523,
		122
	],
	"./vector.svg": [
		1524,
		121
	],
	"./verified.svg": [
		1525,
		120
	],
	"./view-icon.svg": [
		1526,
		119
	],
	"./whatsapp.svg": [
		1527,
		118
	],
	"./worksheet.svg": [
		1528,
		117
	],
	"./write.svg": [
		1529,
		116
	],
	"./wrong.svg": [
		1530,
		115
	],
	"./youtube.svg": [
		1531,
		114
	],
	"./yt-lock.svg": [
		1532,
		113
	],
	"./zoom-in.svg": [
		1533,
		112
	],
	"./zoom-out.svg": [
		1534,
		111
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 407;


//////////////////
// WEBPACK FOOTER
// ./src/components/SvgSymbol/svgs lazy ^\.\/.*\.svg$
// module id = 407
// module chunks = 346